module.exports = __webpack_public_path__ + "static/media/cocktail.43915a62.svg";